export * from './post-herausgeber.service';
export * from './post-herausgeber.service.module';